import { render, staticRenderFns } from "./OrderConfirmationRedirect.vue?vue&type=template&id=72330061&"
import script from "./OrderConfirmationRedirect.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmationRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports